/**
 * Modo escuro (roadmap #23). A preferência fica no navegador; sem escolha,
 * segue o sistema. A classe .dark na raiz liga as variantes do Tailwind e os
 * tokens de estilo.css.
 */
import { guardado } from './armazenamento';

const CHAVE = 'tema';

export function temaSalvo() { return guardado.ler(CHAVE, '') || 'auto'; }

export function temaEfetivo(escolha = temaSalvo()) {
  if (escolha === 'claro' || escolha === 'escuro') return escolha;
  const mq = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)');
  return mq && mq.matches ? 'escuro' : 'claro';
}

export function aplicarTema(escolha = temaSalvo()) {
  const efetivo = temaEfetivo(escolha);
  if (typeof document !== 'undefined') document.documentElement.classList.toggle('dark', efetivo === 'escuro');
  return efetivo;
}

export function salvarTema(escolha) {
  guardado.gravar(CHAVE, escolha);
  return aplicarTema(escolha);
}

/** Chama de volta quando o sistema muda e a escolha é automática. */
export function ouvirSistema(cb) {
  if (typeof window === 'undefined' || !window.matchMedia) return () => {};
  const mq = window.matchMedia('(prefers-color-scheme: dark)');
  const h = () => { if (temaSalvo() === 'auto') cb(aplicarTema('auto')); };
  mq.addEventListener ? mq.addEventListener('change', h) : mq.addListener(h);
  return () => { mq.removeEventListener ? mq.removeEventListener('change', h) : mq.removeListener(h); };
}
